import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
//import './index.css';
import reportWebVitals from './ts/reportWebVitals';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { RootPage } from './pages/RootPage';
import { LoginPage } from './pages/LoginPage';
import { ManagePage } from './pages/ManagePage';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/manage" element={<ManagePage />} />
        <Route path="*" element="not found" />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
